import FaqsEmbeddingLayout from './Layout'
import FaqsEmbeddingList from './List'
import FaqsEmbeddingForm from './Form'

export default [
    {
        path: 'faqs_embedding',
        component: FaqsEmbeddingLayout,
        redirect: {
            name: 'FaqsEmbeddingList'
        },
        name: 'faqsEmbedding',
        meta: {
            breadcrumb: 'FAQs (IA)'
        },
        children: [
            {
                path: 'list',
                alias: '',
                component: FaqsEmbeddingList,
                name: 'FaqsEmbeddingList',
                meta: {
                    breadcrumb: 'Lista'
                }
            },
            {
                path: 'add',
                alias: '',
                component: FaqsEmbeddingForm,
                name: 'FaqsEmbeddingAdd',
                meta: {
                    breadcrumb: 'Agregar'
                }
            },
            {
                path: 'edit/:id',
                alias: '',
                component: FaqsEmbeddingForm,
                name: 'FaqsEmbeddingEdit',
                meta: {
                    breadcrumb: 'Editar'
                }
            }
        ]
    }]
